import React from 'react'
import { CardContainer } from './CardContainer'

interface PageWithCardContainerProps {
  children: React.ReactNode
}

export const PageWithCardContainer: React.FC<PageWithCardContainerProps> = ({ children }) => {
  return (
    <div className="relative flex items-center justify-center min-h-screen bg-cover bg-center bg-login-art">
      <div className={`absolute inset-0 bg-primaryAccentColor opacity-60`}></div>
      <CardContainer variant="flex" className="relative z-10">
        {children}
      </CardContainer>
    </div>
  )
}
